import { PageNotFound } from '@/components/PageNotFound'
import { redirectSearchSchema } from '@/lib/utils/navigation'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

export const Route = createFileRoute('/_auth/_modules/_shared/_errors/not-found')({
  component: RouteComponent,
  validateSearch: zodValidator(redirectSearchSchema),
  beforeLoad: async ({ search }) => {
    if (!search.redirect) throw redirect({ to: '/welcome' })
  },
})

function RouteComponent() {
  return <PageNotFound />
}
